export default function useReadableDate (date) {
    const mapDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    const mapMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const today = new Date()
    const tomorrow = new Date(today)
    const yesterday = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)
    yesterday.setDate(tomorrow.getDate() - 1)

    const eventDate = new Date(date)
    const eventTime = formatTime(eventDate)

    if (eventDate.toDateString() === today.toDateString()) {
        return 'Today ' + eventTime
    } else if (eventDate.toDateString() === tomorrow.toDateString()) {
        return 'Tomorrow ' + eventTime
    } else if (eventDate.toDateString() === yesterday.toDateString()) {
        return 'Yesterday ' + eventTime
    }

    return `${mapDays[eventDate.getDay()]} ${eventDate.getDate()} ${mapMonths[eventDate.getMonth()]} ${eventTime}`
}

const formatTime = eventDate => {
    let hours = eventDate.getHours()
    let minutes = eventDate.getMinutes()
    const ampm = hours >= 12 ? 'pm' : 'am'

    if (hours >= 12) {
        hours = hours - 12
    }
    if (hours === 0) {
        hours = 12
    }
    if (hours <= 9) {
        hours = `0${hours}`
    }
    if (minutes <= 9) {
        minutes = `0${minutes}`
    }

    return `${hours}:${minutes}${ampm}`
}



// WEBPACK FOOTER //
// ./resources/js/hooks/useReadableDate.js